import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import { RouterProvider, createRouter } from '@tanstack/react-router'

import { routeTree } from './routeTree.gen'
import { AppErrorFallback } from './shared/ui/AppErrorFallback'
import './instrumentation-client'
import './index.css'

const router = createRouter({
  routeTree,
  defaultErrorComponent: AppErrorFallback
} as any)

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error('Root element #root not found')
}

// Erro capturado por error boundary não passa por `window.onerror`: o React
// entrega em `onCaughtError`, cujo padrão é só `console.error`. Sem estes
// handlers o `globalHandlersIntegration` do Sentry não enxerga nenhum crash de
// renderização — era por isso que os travamentos relatados pelos alunos não
// geravam um único evento.
createRoot(rootElement, {
  onCaughtError: Sentry.reactErrorHandler(),
  onUncaughtError: Sentry.reactErrorHandler(),
  onRecoverableError: Sentry.reactErrorHandler()
}).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
)
